// extracted by css-extract-rspack-plugin
export default {"bodyText":"AgentAuthorizationDialog-module__bodyText__xtTap","errorText":"AgentAuthorizationDialog-module__errorText__bIveB"};